module.exports = __webpack_public_path__ + "img/Lani.3a88b614.jpg";